// Today's layout is a per-device display preference, like row density:
// 'screen' fits everything into one window with no page scroll; 'full' is the
// long page with the month calendar and quote.
const KEY = 'mind_today_layout';

export const getTodayLayout = () => {
  try {
    return localStorage.getItem(KEY) === 'full' ? 'full' : 'screen';
  } catch {
    return 'screen';
  }
};

export const setTodayLayout = (layout) => {
  try {
    localStorage.setItem(KEY, layout);
  } catch {
    // Private mode: the default applies next time
  }
};
